module.exports = __webpack_public_path__ + "img/gumi-login.12b6457f.png";